import { create } from 'zustand';

const STORAGE_KEY = 'clicked_products';

const safeLocalStorage = {
  get: (key: string): Set<string | number> => {
    try {
      const item = localStorage.getItem(key);
      if (!item) return new Set();
      const ids = JSON.parse(item) as (string | number)[];
      return new Set(ids);
    } catch (error) {
      console.error('Error reading clicked products from localStorage:', error);
      return new Set();
    }
  },
  set: (key: string, value: Set<string | number>): void => {
    try {
      const ids = Array.from(value);
      localStorage.setItem(key, JSON.stringify(ids));
    } catch (error) {
      console.error('Error writing clicked products to localStorage:', error);
    }
  },
};

type ClickedProductsStore = {
  clickedProducts: Set<string | number>;
  handleProductClick: (productId: string | number) => void;
  clearClickedProducts: () => void;
};

const useClickedProductsStore = create<ClickedProductsStore>((set) => ({
  clickedProducts: safeLocalStorage.get(STORAGE_KEY),
  handleProductClick: (productId: string | number) => {
    set((state) => {
      const newSet = new Set(state.clickedProducts);
      if (newSet.has(productId)) {
        newSet.delete(productId);
      } else {
        newSet.add(productId);
      }
      return { clickedProducts: newSet };
    });
  },
  clearClickedProducts: () => {
    set({ clickedProducts: new Set() });
  },
}));

// Subscribe to changes and persist to localStorage
useClickedProductsStore.subscribe((state) => {
  safeLocalStorage.set(STORAGE_KEY, state.clickedProducts);
});

export default useClickedProductsStore;
